import React, { Component } from 'react';
import { connect } from 'react-redux';
import { applyOnEnum, isEmpty} from '../../../utils/helpers';
import ReactHtmlParser from 'react-html-parser';
import Loader from '../../Loader';
import moment from 'moment';
import DatePicker from "react-datepicker";
import { getAllWorkflowDefinitionAttributes } from '../../../actions/workflow.actions';
import { getWorkflowDefinitionReasonCodes, getWorkflowDefinitionAttributes, getWorkflowAttributesByServiceOrder, getWorkflowReasonCodesByServiceOrder } from '../../../actions/accountDetailsActions/accountDetails.actions';
import { showModal, hideModal } from '../../../actions/modal.actions';

class SummaryContainer extends Component {
	state = {
		isApplyOnVisible: false,
		startDate: this.props.accountInfo.billCycle? this.convertDay(this.props.accountInfo.billCycle): this.convertDay((new Date()).getDate()),
		applyOnType: Object.keys(applyOnEnum)[0],
		reasonCodes: [],
		workflowAttributes: [],
	}

	componentDidMount() {
		const serviceOrderId = this.props.values && this.props.values.serviceOrderId;
		const isEditServiceOrder = !!serviceOrderId;
		let existingApplyOn = null;
		let existingReasonCodeId = null;
		if (isEditServiceOrder && this.props.initialValues) {
			existingApplyOn = this.props.initialValues.applyOn;
			existingReasonCodeId = this.props.initialValues.serviceOrder && this.props.initialValues.serviceOrder.reasoncodeId;
		}
		let planCategory = 'RESIDENTIAL';
		let serviceModel = 'INTERNET';
		let workflowType = 'NEW_SIGNUP';

		if (isEditServiceOrder) {
			if (this.props.planDetails && this.props.planDetails.serviceModel) {
				serviceModel = this.props.planDetails.serviceModel.name || 'INTERNET';
			}
		} else {
			if (this.props.values && this.props.values.plans && this.props.values.plans.length > 0) {
				const firstPlan = this.props.values.plans[0];
				if (firstPlan.planDescription) {
					const description = firstPlan.planDescription.toLowerCase();
					if (description.includes('business')) {
						planCategory = 'BUSINESS';
					} else if (description.includes('residential')) {
						planCategory = 'RESIDENTIAL';
					}
				}
				serviceModel = firstPlan.serviceModel?.name || 'INTERNET';
				workflowType = 'NEW_SIGNUP';
			}
		}

		if (isEditServiceOrder) {
			if (this.props.getWorkflowReasonCodesByServiceOrder) {
				this.props.getWorkflowReasonCodesByServiceOrder(serviceOrderId)
					.then((response) => {
						let reasonCodes = response.data.apiReasoncodeList || [];
						if (!Array.isArray(reasonCodes)) {
							reasonCodes = [];
						}
						this.setState({reasonCodes: reasonCodes});
					})
					.catch((error) => {
						console.error('Error fetching Workflow Reason Codes by Service Order:', error);
					});
			}

			if (this.props.getWorkflowAttributesByServiceOrder) {
				this.props.getWorkflowAttributesByServiceOrder(serviceOrderId)
					.then((response) => {
						let workflowAttributes = response.data.workflowDefinitionAttributesList;
						if (!Array.isArray(workflowAttributes)) {
							workflowAttributes = [];
						}
						let applyOnType = existingApplyOn || Object.keys(applyOnEnum)[0];
						if (workflowAttributes.length > 0) {
							const attributes = workflowAttributes[0];
							const allowedOptions = [
								attributes.allowOrderCompletion,
								attributes.allowStartOfBillCycle,
								attributes.allowNextBillCycle,
								attributes.allowSelectADate
							].filter(Boolean).length;

							if (!existingApplyOn) {
								if (allowedOptions === 1) {
									if (attributes.allowOrderCompletion) {
										applyOnType = Object.keys(applyOnEnum)[0];
									} else if (attributes.allowStartOfBillCycle) {
										applyOnType = Object.keys(applyOnEnum)[1];
									} else if (attributes.allowNextBillCycle) {
										applyOnType = Object.keys(applyOnEnum)[2];
									} else if (attributes.allowSelectADate) {
										applyOnType = Object.keys(applyOnEnum)[3];
									}
								} else if (allowedOptions > 1) {
									if (attributes.orderCompletionDefault && attributes.allowOrderCompletion) {
										applyOnType = Object.keys(applyOnEnum)[0];
									} else if (attributes.startOfBillCycleDefault && attributes.allowStartOfBillCycle) {
										applyOnType = Object.keys(applyOnEnum)[1];
									} else if (attributes.nextBillCycleDefault && attributes.allowNextBillCycle) {
										applyOnType = Object.keys(applyOnEnum)[2];
									} else if (attributes.selectADateDefault && attributes.allowSelectADate) {
										applyOnType = Object.keys(applyOnEnum)[3];
									}
								}
							}
						}

						this.setState({
							workflowAttributes: workflowAttributes,
							applyOnType: applyOnType
						});
					})
					.catch((error) => {
						console.error('Error fetching Workflow Attributes by Service Order:', error);
					});
			}
		} else {
			if (this.props.getWorkflowDefinitionReasonCodes) {
				this.props.getWorkflowDefinitionReasonCodes(planCategory, serviceModel, workflowType, 'CAMVIO-WEB')
					.then((response) => {
						const reasonCodes = response.data.apiReasoncodeList || [];
						this.setState({reasonCodes: reasonCodes});
            if ((reasonCodes.length > 0) && (this.props.values.reasoncodeId == null)) {
              this.props.setFieldValue('reasoncodeId', reasonCodes[0].id);
            }
					})
					.catch((error) => {
						console.error('Error fetching Workflow Definition Reason Codes:', error);
					});
			}

			if (this.props.getWorkflowDefinitionAttributes) {
				this.props.getWorkflowDefinitionAttributes(planCategory, serviceModel, workflowType, 'CAMVIO-WEB')
					.then((response) => {
						this.setState({workflowAttributes: response.data.workflowDefinitionAttributesList});
					})
					.catch((error) => {
						console.error('Error fetching Workflow Definition Attributes:', error);
					});
			}
		}
	}

	handleApplyOnDropdown = () => {
		this.setState((prevState) => ({
			isApplyOnVisible: !prevState.isApplyOnVisible
		}));
	}

	 convertDay(startDayBillCycle){
		let localdate = new Date();
		let currentMonth = localdate.getMonth();
		let currentYear = localdate.getFullYear();
		let currentDay = localdate.getDate();
		if( startDayBillCycle <= currentDay ) {
			return new Date(currentYear,currentMonth,startDayBillCycle);
		}else{
			return new Date(currentYear,currentMonth-1,startDayBillCycle);
		}
	}
	handleChangeApplyOn = (value) => {
		if (value) {
			this.props.values.applyOn = value;
			/**
			 * If User doesn't manually select a date,
			 * we remove apply on Date and set description for modal.
			 * If they did select a date, we handle in handlChangeStartDateBillCycle
			 */
			if(Object.keys(applyOnEnum)[3] !== value) {
				this.props.setApplyOnDate({applyOnPeriod: applyOnEnum.valueOf()[value].toLowerCase(), applyOnDate:""})
			}
		}
	}


	openDatepicker = () => {
		//opens calendar and sets default date to present
		this._calendar.setOpen(true);
		if(!this.props.values.applyOn) {
			this.props.setFieldValue('applyDate', moment().format('YYYY-MM-DD'));
		}
	}

	handlChangeStartDateBillCycle = (value) => {
		if (value instanceof Date) {
			value = moment(value).format('YYYY-MM-DD');
		}

		if(value) {
			this.props.setFieldValue('applyDate', value);
			this.props.setApplyOnDate({applyOnPeriod: "APPLY_ON_DATE", applyOnDate:value})

		}
	};

	handleShowApplyOnModal = () => {
		const { showModal } = this.props;
		const { workflowAttributes, reasonCodes } = this.state;

		const serviceOrderId = this.props.values && this.props.values.serviceOrderId;
		const isEditServiceOrder = !!serviceOrderId;

		let attributes = null;
		if (workflowAttributes.length > 0) {
			attributes = { ...workflowAttributes[0] };
			if (!isEditServiceOrder) {
				attributes.allowProvisionImmediately = false;
				attributes.provisionImmediatelyDefault = false;
			}
		} else {
			if (isEditServiceOrder) {
				attributes = {};
			} else {
				attributes = {
					allowOrderCompletion: true,
					allowStartOfBillCycle: true,
					allowNextBillCycle: true,
					allowSelectADate: true,
					allowProvisionImmediately: false,
					orderCompletionDefault: true,
					startOfBillCycleDefault: false,
					nextBillCycleDefault: false,
					selectADateDefault: false,
					provisionImmediatelyDefault: false
				};
			}
		}
		const mockStatusTransition = {
			name: 'APPLY ON',
			fromStatus: 'Current',
			toStatus: 'Updated',
			workflowDefinitionAttributes: attributes,
			workflowDefinitionReasoncodes: reasonCodes.map(reason => ({
				reasoncode: {
					id: reason.id,
					description: reason.description
				}
			})),
			isLinesModal: true,
			isNewOrderModal: true
		};

		showModal('ACCOUNT_STATUS_CHANGE_MODAL', {
			accountInfo: this.props.accountInfo,
			statusTransition: mockStatusTransition,
			onAccountStatusChange: this.handleApplyOnModalSubmit,
			onModalSubmit: this.handleModalValuesSubmit,
			currentValues: {
				applyOnType: this.props.values && this.props.values.applyOn ?
					this.props.values.applyOn :
					(this.props.initialValues && this.props.initialValues.applyOn ?
						this.props.initialValues.applyOn : this.state.applyOnType),
				applyOnDate: this.props.values && this.props.values.applyDate ?
					moment(this.props.values.applyDate).format('YYYY-MM-DD') :
					(this.props.initialValues && this.props.initialValues.applyDate ?
						moment(this.props.initialValues.applyDate).format('YYYY-MM-DD') : null),
				provisionImmediately: false,
				reasoncodeId: this.props.values && this.props.values.reasoncodeId ?
					this.props.values.reasoncodeId :
					(this.props.initialValues && this.props.initialValues.serviceOrder ?
						this.props.initialValues.serviceOrder.reasoncodeId : null)
			}
		});
	}

	handleModalValuesSubmit = (applyOnType, applyOnDate, provisionImmediately, reasoncodeId) => {
		if (this.props.setFieldValue) {
			this.props.setFieldValue('applyOn', applyOnType);
			const formattedDate = applyOnDate ? moment(applyOnDate).format('YYYY-MM-DD') : applyOnDate;
			this.props.setFieldValue('applyDate', formattedDate);
			this.props.setFieldValue('reasoncodeId', reasoncodeId);
		}
		if (this.props.setApplyOnDate) {
			const applyOnData = {
				applyOnPeriod: applyOnType === Object.keys(applyOnEnum)[3] ? "APPLY_ON_DATE" : applyOnEnum.valueOf()[applyOnType]?.toLowerCase(),
				applyOnDate: applyOnDate ? moment(applyOnDate).format('YYYY-MM-DD') : ""
			};
			this.props.setApplyOnDate(applyOnData);
		}

		this.setState({
			applyOnType: applyOnType
		});
	}

	renderApplyOnText = (applyOn, applyDate) => {
		if(applyOn === Object.keys(applyOnEnum)[3]) {
			return `Are you sure you would like for your order to be applied on ${applyDate}?`
		} else {
			return `Are you sure you would like for your order to be applied on ${applyOnEnum.valueOf()[applyOn]}?`
		}
	}

	handleApplyOnModalSubmit = () => {

	}

	getApplyOnTypeLabel = () => {
		const applyOnType = this.props.values && this.props.values.applyOn ?
			this.props.values.applyOn :
			(this.props.initialValues && this.props.initialValues.applyOn ?
				this.props.initialValues.applyOn : this.state.applyOnType);

		if (applyOnType && applyOnEnum.valueOf()[applyOnType]) {
			return applyOnEnum.valueOf()[applyOnType].toUpperCase();
		}
		return "ORDER COMPLETION";
	}

	getApplyOnTypeDescription = () => {
		const applyOnType = this.props.values && this.props.values.applyOn ?
			this.props.values.applyOn :
			(this.props.initialValues && this.props.initialValues.applyOn ?
				this.props.initialValues.applyOn : this.state.applyOnType);

		switch(applyOnType) {
			case Object.keys(applyOnEnum)[0]:
				return "Order Completion";
			case Object.keys(applyOnEnum)[1]:
				return "Start of Bill Cycle";
			case Object.keys(applyOnEnum)[2]:
				return "Next Bill Cycle";
			case Object.keys(applyOnEnum)[3]:
				const selectedDate = this.props.values && this.props.values.applyDate ?
					this.props.values.applyDate :
					(this.props.initialValues && this.props.initialValues.applyDate ?
						this.props.initialValues.applyDate : null);
				if (selectedDate) {
					return `Selected Date: ${moment(selectedDate).format('MM/DD/YYYY')}`;
				}
				return "Select a Date";
			default:
				return "Order Completion";
		}
	}

	getSelectedReasonLabel = () => {
		const { reasonCodes } = this.state;

		let reasoncodeId = this.props.values ? this.props.values.reasoncodeId : null;
		if (!reasoncodeId && this.props.initialValues && this.props.initialValues.serviceOrder) {
			reasoncodeId = this.props.initialValues.serviceOrder.reasoncodeId;
		}

		if (!reasoncodeId) {
			if (reasonCodes.length === 0) {
				return "NO REASON CODES LOADED";
			}
			return reasonCodes.length > 0 ? (reasonCodes[0].name || reasonCodes[0].description).toUpperCase() : "NO REASON SELECTED";
		}

		const selectedReason = reasonCodes.find(reason => reason.id === reasoncodeId);
		return selectedReason ? (selectedReason.name || selectedReason.description).toUpperCase() : "NO REASON SELECTED";
	}

	getSelectedReasonDescription = () => {
		const { reasonCodes } = this.state;

		let reasoncodeId = this.props.values ? this.props.values.reasoncodeId : null;
		if (!reasoncodeId && this.props.initialValues && this.props.initialValues.serviceOrder) {
			reasoncodeId = this.props.initialValues.serviceOrder.reasoncodeId;
		}

		if (!reasoncodeId) {
			if (reasonCodes.length === 0) {
				return "No Reason Codes Loaded";
			}
			return reasonCodes.length > 0 ? reasonCodes[0].description : "";
		}

		const selectedReason = reasonCodes.find(reason => reason.id === reasoncodeId);
		return selectedReason ? selectedReason.description : "";
	}

	render() {

		const {
			isApplyOnVisible,
			startDate,
		} = this.state;

		const {
			values,
			isSummaryFullWith,
			handleFullWithSummary,
			isSummaryCollapsed,
			handleSummaryCollapsed,
			tab,
		} = this.props;

		if (isEmpty(values.plans)) {
			return <Loader />;
		}

		return (
			<div className={"col-lg-3 col-xl-4 panel-summary" + (isSummaryFullWith === true ? ' col-full-width' : '')}>
				<div className="services-summary">
					<div className="services-summary-header">

						Summary

						<span className="ml-auto">
							<a className="btn-summary btn-summary-toggle" onClick={handleFullWithSummary}>
								<i className="fas fa-arrows-alt-h" />&nbsp;View
							</a>
							<a className="btn-summary btn-summary-collapse" onClick={handleSummaryCollapsed}>
								<i className="fas fa-angle-double-up" />&nbsp;Collapse
							</a>
						</span>

					</div>

					{(tab === 'Products' || tab === 'Services') &&
					<div className="services-summary-applyon d-flex justify-content-center">
						<div className="row">
							<div className="col-12">
								<div className="d-flex justify-content-center align-items-start">
									<div className="mr-4">
										<label className="text-muted small mb-1 d-block">Apply On</label>
										<div
											className="cursor-pointer"
											onClick={this.handleShowApplyOnModal}
											style={{ cursor: "pointer" }}
										>
											<span className="btn btn-sm btn-outline-secondary dropdown-toggle" style={{verticalAlign: 'middle'}}>{this.getApplyOnTypeLabel()}</span>
											{this.getApplyOnTypeDescription() && (
												<>
													<div className="text-muted small mt-1" style={{fontSize: '12px'}}>
														{this.getApplyOnTypeDescription()}
													</div>
													{/*{(this.state.applyOnType === Object.keys(applyOnEnum)[0] || this.state.applyOnType === Object.keys(applyOnEnum)[1] || (this.props.values && this.props.values.provisionImmediately)) && (*/}
													{/*	<div className="text-muted small mt-1" style={{fontSize: '12px'}}>*/}
													{/*		Provision Immediately*/}
													{/*	</div>*/}
													{/*)}*/}
												</>
											)}
										</div>
									</div>
									<div>
										<label className="text-muted small mb-1 d-block">Reason</label>
										<div
											className="cursor-pointer"
											onClick={this.handleShowApplyOnModal}
											style={{ cursor: "pointer" }}
										>
											<span className="badge badge-primary text-white" style={{fontSize: '.875rem', padding: '0.25rem 0.5rem', lineHeight: '1.7', borderRadius: '0.2rem', verticalAlign: 'middle'}}>
												{this.getSelectedReasonLabel()}
											</span>
											{this.getSelectedReasonDescription() && (
												<div className="text-muted small mt-1" style={{fontSize: '12px'}}>
													{this.getSelectedReasonDescription()}
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					}


					{/*{values.applyOn && values.applyOn === Object.keys(applyOnEnum)[3] && (tab === 'Products' || tab === 'Services') ?*/}
					{/*	<div className="form-group d-flex">*/}
					{/*		<div className='dropdown dropdown-cn-expiration ml-1 show'>*/}
					{/*			<h6 className="dropdown-header">Choose a Date: </h6>*/}
					{/*			<div className="form-group col">*/}
					{/*				<div*/}
					{/*					className="input-group input-group-sm date"*/}
					{/*					id="datetimepicker-cn-exp"*/}
					{/*					data-target-input="nearest"*/}
					{/*				>*/}
					{/*					<DatePicker*/}
					{/*						className="form-control datetimepicker-input"*/}
					{/*						selected={this.props.values.applyDate && moment(this.props.values.applyDate, 'YYYY-MM-DD').isValid() ? moment(this.props.values.applyDate, 'YYYY-MM-DD').toDate() : null}*/}
					{/*						minDate={startDate}*/}
					{/*						onChange={(date) => {*/}
					{/*							this.handlChangeStartDateBillCycle(date);*/}
					{/*							this.openDatepicker()*/}
					{/*						}}*/}
					{/*						placeholderText="MM/DD/YYYY"*/}
					{/*						name="expirationDate"*/}
					{/*						popperPlacement="bottom-end"*/}
					{/*						ref={(c) => this._calendar = c}*/}
					{/*					/>*/}
					{/*				</div>*/}
					{/*			</div>*/}
					{/*			/!*        <div className="dropdown-item">*/}
          {/*                      <button type="button"*/}
          {/*                              className="btn btn-outline-secondary btn-block btn-cn-exp-date-clear"*/}
          {/*                              onClick={this.handleClearExpirationDate}>Save*/}
          {/*                      </button>*/}
          {/*                  </div> *!/*/}
					{/*		</div>*/}
					{/*	</div>*/}

					{/*	: ''*/}
					{/*}*/}

					<div className="services-summary-body">
						{values.plans.sort((a, b) => a.planId - b.planId).map((plan) => (
							<div className="plan-wrapper" data-plan-type="wireless" key={plan.planId}>

								<h4>{plan.planDescription}</h4>

								{!isEmpty(plan.servicelines) && plan.servicelines.map((serviceline, index) => (
									<div className="serviceline-wrapper" key={index}>

										<h5 className="clearfix">
											<span className="badge badge-line-type">{serviceline.serviceLineRelation}</span>
											<span className="float-right">{serviceline.number}</span>
										</h5>

										<div className="plan-section" data-opt-pmnt-type="pmnt-recurring">

											<h5>Recurring</h5>

											{serviceline.features && serviceline.features.filter((x) => x.featureType !== 'ACTIVATION').map((feature, inx, arr) => (
											<div className="package-wrapper" key={inx}>
												<div className={"package-option" + (isSummaryCollapsed === false ? ' just-added' : ' d-none')}>
													<span className="po-title">
														{feature.featurePackageDescription
															? feature.description
																? ReactHtmlParser(`${feature.featurePackageDescription}: ${feature.description}`)
																: ReactHtmlParser(`${feature.featurePackageDescription}`)
															: ReactHtmlParser(`${feature.description}`)}
													</span>
													<span className="po-price">
                                                        {feature.featureVariabledQuantity
															? feature.recurringMonthlyPrice &&
															("$" + (feature.featureVariabledQuantity * Number(feature.recurringMonthlyPrice)).toFixed(2).replace(/\d(?=(\d{3}) +\.)/g, '$&,') + "/mo")
															: feature.recurringMonthlyPrice &&
															("$" + Number(feature.recurringMonthlyPrice).toFixed(2).replace(/\d(?=(\d{3}) +\.)/g, '$&,') + "/mo")
														}
													</span>
												</div>
											</div>
											))}

											<p className="services-price-subtotal">
												Subtotal:&nbsp;<span className="service-price">
													${serviceline.features && serviceline.features.reduce((acc, currentValue, index) => {
														if (currentValue.featureType !== 'ACTIVATION') {
															if (currentValue.featureVariabledQuantity) {
																if (currentValue.recurringMonthlyPrice) {
																	acc += currentValue.featureVariabledQuantity *
																		currentValue.recurringMonthlyPrice;
																}
															}
															else if (currentValue.recurringMonthlyPrice) {
																acc += Number(currentValue.recurringMonthlyPrice);
															}
														}
														return Number(acc);
													}, 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}/mo
												</span>
											</p>

										</div>
										<div className="plan-section" data-opt-pmnt-type="pmnt-onetime">

											<h5>Onetime</h5>

											{serviceline.features && serviceline.features.filter((x) => x.featureType === 'ACTIVATION').map((feature, inx, arr) => (
											<div className="package-wrapper" key={inx}>
												<div className={"package-option" + (isSummaryCollapsed === false ? ' just-added' : ' d-none')}>
													<span className="po-title">
														{feature.featurePackageDescription
															? feature.description
																? ReactHtmlParser(`${feature.featurePackageDescription}: ${feature.description}`)
																: ReactHtmlParser(`${feature.featurePackageDescription}`)
															: ReactHtmlParser(`${feature.description}`)}
													</span>
													<span className="po-price">
														${Number(feature.oneTimePrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
													</span>
												</div>
											</div>
											))}

											<p className="services-price-subtotal">
												Subtotal:&nbsp;<span className="service-price">
													${serviceline.features && serviceline.features.reduce((acc, currentValue, index) => {
														if (currentValue.featureType === 'ACTIVATION' && currentValue.oneTimePrice !== undefined)
															acc += Number(currentValue.oneTimePrice);
													return Number(acc);
													}, 0)
													.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
												</span>
											</p>

										</div>
										{serviceline.devices && serviceline.devices.length > 0 ?
										<div className="plan-section" data-opt-pmnt-type="pmnt-equipment">

												<h5>Equipment</h5>

												<div className="package-wrapper">
													{serviceline.devices && serviceline.devices.map((device, inx, arr) => (
														<div
															className={"package-option" + (isSummaryCollapsed === false ? ' just-added' : ' d-none')}
															key={inx}>
													<span className="po-title">
														{ReactHtmlParser(device.itemDescription)}
													</span>
															<span className="po-price">
														{!isEmpty(device.itemPrice)
															? ('$' + device.itemPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))
															: ''}
													</span>
														</div>
													))}
												</div>

											<p className="services-price-subtotal">
												Subtotal:&nbsp;<span className="service-price">
													${serviceline.devices ?(
													serviceline.devices.reduce((acc, currentValue, index) => {
														if (currentValue.itemPrice !== undefined)
															acc += currentValue.itemPrice;
														return acc;
													}, 0)
														.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')) :
												(0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
												</span>
											</p>

										</div>
											: ''
										}

									</div>
								))}
							</div>
						))}
					</div>

					<div className="services-summary-footer">

						<p>Grand Total</p>

						<p className="services-price-total">
							Recurring:{' '}
							<span className="service-price">
								${values.plans.reduce((acc, currentValue, index) => {
									currentValue.servicelines.map((serviceline) => {
										serviceline.features && serviceline.features.map((feature) => {
											if (feature.featureType !== 'ACTIVATION') {
												if (feature.featureVariabledQuantity) {
													if (feature.recurringMonthlyPrice) {
														acc += feature.featureVariabledQuantity *
															feature.recurringMonthlyPrice;
													}
												}
												else if (feature.recurringMonthlyPrice) {
													acc += Number(feature.recurringMonthlyPrice);
												}
											}
										});
									});
									return Number(acc);
								}, 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}/mo
							</span>
						</p>

						<p className="services-price-total">
							OneTime:{' '}
							<span className="service-price">
								${values.plans.reduce((acc, currentValue, index) => {
									currentValue.servicelines.map((serviceline) => {
										serviceline.features && serviceline.features.map((feature) => {
											if (feature.featureType === 'ACTIVATION' && feature.oneTimePrice !== undefined) {
												acc += Number(feature.oneTimePrice);
											}
										});
									});
									return acc;
								}, 0)
								.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
							</span>
						</p>

						<p className="services-price-total">
							Equipment:{' '}
							<span className="service-price">
								${values.plans.reduce((acc, currentValue, index) => {
									currentValue.servicelines.map((serviceline) => {
										if (typeof serviceline.devices !== 'undefined' && serviceline.devices != null) {
											serviceline.devices.map((device) => {
												if (device.itemPrice !== undefined) {
													acc += device.itemPrice;
												}
											});
										}
									});
									return acc;
								}, 0)
								.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
							</span>
						</p>

					</div>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = {
	getAllWorkflowDefinitionAttributes,
	getWorkflowDefinitionReasonCodes,
	getWorkflowDefinitionAttributes,
	getWorkflowAttributesByServiceOrder,
	getWorkflowReasonCodesByServiceOrder,
	showModal,
	hideModal
};

export default connect(null, mapDispatchToProps)(SummaryContainer);
